<div class="layout-column">
    <span *ngIf="!isBundle"
          class="text-capitalize text-ellipsis"
          [ngClass]="purpose + ' ' +  (textClass || 'br-body-1')">
        {{'TASK_PURPOSE.' + text | translate}}
    </span>

  <span *ngIf="isBundle"
        class="text-capitalize text-ellipsis"
        [ngClass]="purpose + ' ' +  (textClass || 'br-body-1')">
    {{'Multi ' + purpose | translate}}
    </span>
</div>
